import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * 用于配置布局相关的设置
 * @see https://procomponents.ant.design/components/layout
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#2CA6E0',
  //-- 菜单布局方式，混合布局
  layout: 'mix',
  contentWidth: 'Fluid',
  //-- 固定header
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: ' ', //-- 使用图片作为标题，此处不显示
  pwa: true,
  iconfontUrl: '',
  token: {
    //-- 项目背景色
    bgLayout: '#F4F4F6',
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    sider: {
      colorMenuBackground: 'rgba(255,255,255)',
      colorBgCollapsedButton: '#2CA6E0',
      colorTextCollapsedButton: 'rgba(255,255,255)',
      colorTextCollapsedButtonHover: 'rgba(255,255,255)',
      colorTextMenuSelected: '#2CA6E0',
      colorTextMenuActive: '#2CA6E0',
    },
  },
};

export default Settings;
